import { c as b, j as s } from "./utils-BdNIfrGQ.js";
import { L as H } from "./Label-kWLyCHVQ.js";
import N, { useRef as y, useCallback as R, useLayoutEffect as z } from "react";
import { I as L } from "./BaseInput.styles-Bn99zfPn.js";
import { c as f } from "./index-Di82Y7n3.js";
import { D as M } from "./Div-spVpsZsH.js";
import "./Div.skeleton-DLnqOZrU.js";
import { F as B } from "./Flex-BA9xHq_p.js";
import "./Grid-DJGISvmf.js";
const I = f(
  "pl-5 pr-4 w-full items-center rounded-[8px] bg-white focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border border-gray-400 min-h-[40px] gap-0",
        cta: "rounded-r-[32px] border border-gray-100 shadow min-h-[40px] pr-0"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), X = f("", {
  variants: {
    variant: {
      default: "",
      cta: "[&>button]:py-4"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), Y = f("", {
  variants: {
    variant: {
      default: "hidden",
      cta: "block"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), G = {
  default: { variant: "ghost", size: "icon" },
  cta: { variant: "outline", size: "sm" }
}, _ = f("", {
  variants: {
    variant: {
      default: b(I(), "items-end py-4"),
      composer: "w-full items-center rounded-[8px] border border-border bg-card py-[6px] pl-5 pr-5 shadow focus-within:border-primary focus-within:ring-1 focus-within:ring-primary"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), T = 6, k = (m) => {
  const { element: t, minRows: a, maxRows: h = T } = m;
  t.style.height = "auto";
  const r = window.getComputedStyle(t), l = Number.parseFloat(r.lineHeight) || 24, n = Number.parseFloat(r.paddingTop) || 0, c = Number.parseFloat(r.paddingBottom) || 0, g = l * a + n + c, u = l * Math.max(h, a) + n + c, i = Math.min(Math.max(t.scrollHeight, g), u);
  return t.style.height = `${i}px`, t.style.overflowY = t.scrollHeight > u ? "auto" : "hidden", i;
}, D = N.forwardRef(
  (m, t) => {
    const {
      label: a,
      helperText: h,
      error: r,
      spacing: l,
      hideLabel: n = !1,
      action: c,
      onChange: g,
      rows: u,
      maxRows: i = T,
      expandable: d = !0,
      variant: C = "default",
      ...p
    } = m, v = y(null), x = y(null), w = u ?? 2, o = R(
      (e) => {
        if (e && d) {
          const F = k({ element: e, minRows: w, maxRows: i });
          x.current && (x.current.style.height = `${F}px`);
        }
      },
      [d, i, w]
    ), V = R(
      (e) => {
        v.current = e, typeof t == "function" ? t(e) : t && (t.current = e), o(e);
      },
      [o, t]
    );
    z(() => {
      o(v.current);
    }, [o, p.value]);
    const j = (e) => {
      g?.(e), o(e.currentTarget);
    };
    return /* @__PURE__ */ s.jsxs(L, { spacing: l, size: "full", children: [
      /* @__PURE__ */ s.jsx(
        H,
        {
          htmlFor: p.id,
          helperText: h,
          required: p.required,
          variant: n ? "hidden" : "visible",
          children: a
        }
      ),
      /* @__PURE__ */ s.jsxs(B, { className: _({ variant: C }), gap: "4", children: [
        /* @__PURE__ */ s.jsx(
          M,
          {
            ref: x,
            className: b(
              "min-w-0 flex-1",
              d && "overflow-hidden transition-[height] duration-150 ease-out motion-reduce:transition-none"
            ),
            children: /* @__PURE__ */ s.jsx(
              "textarea",
              {
                className: b(
                  "block border-none appearance-none outline-none bg-transparent w-full min-w-0 resize-none focus:outline-none focus:ring-0",
                  !d && "overflow-y-auto"
                ),
                ref: V,
                rows: w,
                "aria-label": n ? a : void 0,
                ...p,
                onChange: j
              }
            )
          }
        ),
        c
      ] }),
      r
    ] });
  }
);
D.displayName = "TextareaInput";
export {
  D as T,
  Y as a,
  X as b,
  G as c,
  I as s
};
